import React from "react";
import signOut from "../functions/cerrarSesion";
import { Container, Stack, Button, Form, Table } from "react-bootstrap";
import getAllProducts from "../functions/Produccion/getAllProducts";
import getProductos_presentaciones from "../functions/Produccion/Presentaciones/getProductos_presentaciones";
import getProductos_presentaciones2 from "../functions/Produccion/Presentaciones/getProductos_presentaciones2";
import getProductos_presentaciones_diario from "../functions/Produccion/Presentaciones/getProductos_presentaciones_diario";
import eliminarProductoHome from "../functions/Produccion/eliminarProductoHome";
import eliminar_presentaciones from "../functions/Produccion/Presentaciones/eliminar_presentaciones";
import Navbartrabajo from '../../Navbars/Navbartrabajo'
import eliminarAlmacen_empaque_carton_KGCULTIVO from "../functions/Produccion/eliminarAlmacen_empaque_carton_KGCULTIVO";
import getManifiesto_lugares_caja from "../functions/Produccion/getManifiesto_lugares_caja";
import getUsuarios from "../functions/Almacen_campo/getUsuarios";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Swal from "sweetalert2";

//Gastos
import getProductos_gastos from "../functions/Almacen_empaque/getProductos_gastos";
import añadir_total_gastos from "../functions/Almacen_empaque/añadir_total_gastos";
//Embarque 
import Modalagregar_precios_pallets from "../components/Produccion/Modalagregar_precios_pallets";
import getClientes_Embarque from "../functions/Produccion/getClientes_Embarque";
import ModalAñadir_manifiesto_facturas from "../components/Produccion/ModalAñadir_manifiesto_facturas";

import ModalAñadir_Embarque from "../components/Produccion/ModalAñadir_Embarque";
import ModalEditar_Embarque from "../components/Produccion/ModalEditar_Embarque";
import ModalClientes_Embarque from "../components/Produccion/ModalClientes_Embarque";
import getAllmanifiestos from "../functions/Produccion/getAllmanifiestos";
import getAllPallets from "../functions/Produccion/getAllPallets";
import ModalAñadir_Manifiesto_pallets from "../components/Produccion/ModalAñadir_Manifiesto_pallets";
import ModalEditar_Manifiesto_pallets from "../components/Produccion/ModalEditar_Manifiesto_pallets";
import eliminarManifiesto_tarima from "../functions/Produccion/eliminarManifiesto_tarima";
import eliminarManifiesto from "../functions/Produccion/eliminarManifiesto";
import getProductos_manifiesto from "../functions/Produccion/getProductos_manifiesto";
import getLugares_caja from "../functions/Produccion/getLugares_caja";
import getProductos_empaque from "../functions/Produccion/getProductos_empaque";
import ModalPallets from "../components/Produccion/ModalPallets";
import getAllPagos from "../functions/Produccion/getAllPagos";
import eliminarPagos_manifiestos from "../functions/Produccion/eliminarPagos_manifiestos";
//Cartera nacional
import ModalCartera_nacional from "../components/Produccion/ModalCartera_nacional";
//Cartera exportacion
import ModalCartera_exportacion from "../components/Produccion/ModalCartera_exportacion";
//modales
import ModalAñadir from "../components/Produccion/ModalAñadir";
import ModalEditar from "../components/Produccion/ModalEditar";
import ModalProduccion_diaria from "../components/Produccion/ModalProduccion_diaria";
import ModalProduccion_semanal from "../components/Produccion/ModalProduccion_semanal";
import ModalAñadir_presentaciones from "../components/Produccion/ModalAñadir_presentaciones";
import ModalEditar_presentaciones from "../components/Produccion/ModalEditar_presentaciones";


function Home_Produccion({ usuario, pagina, start ,Pagina_principal}) {

  //Convertir a formato moneda
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  })
  
 //Eliminar con sweetalert2
 function eliminar_sweetalert(producto, usuario) {
  Swal.fire({
    title: '¿Esta seguro de eliminar el manifiesto?  "'+ producto.manifiesto+'"',
    text: "Esta acción no se puede restablecer!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si, eliminar.'
  }).then((result) => {
    if (result.isConfirmed) {
      //Traer las tarimas del manifiesto
      getAllPallets(producto).then((productos2) => {
        console.log(productos2)
        if(productos2.length==0){
          getAllPagos(producto).then((PagosDB) => {
              console.log(PagosDB)
             //Con este map elimino todos los pagos que se hicieron de este manifiesto al eliminar el manifiesto 
              PagosDB.map((valor)=>{
                eliminarPagos_manifiestos(valor);
              }) 
                    eliminarManifiesto(producto, usuario.email).then(
                      (confirmacion) => {
                        actualizarEstadoManifiestos();
                        Swal.fire(
                          'Eliminado!',
                          'El manifiesto ha sido eliminada.',
                          'success'
                        )
                      }
                    );
            })
        }else{
          Swal.fire({
            icon: 'error',
            text: "Para poder eliminar el manifiesto, es necesario eliminar todos los pallets que contiene, una vez se encuentre sin pallets se podra eliminar.",
            footer: '¿Que hacer? <br/> Se debe ingresar a "Pallets" del manifiesto seleccionado y eliminarlos.'
          }) 
         }
     }); 
    }
  })
}


const [ADMIN_ON, setADMIN_ON] = React.useState(false);
async function usuario_actual() {
  await getUsuarios().then((UsuariosDB) => {
      console.log(usuario.email);
      UsuariosDB.map((valor)=>{
        if(valor.correo==usuario.email){
          if(valor.rol=="Administrador"){
            setADMIN_ON(true);
          }
        }
      })
   });
 }




//Lineas de produccion, presentaciones de productos
const [presentaciones, setpresentaciones] = React.useState(false);

const [Tomate, setTomate] = React.useState(false);
const [Calabaza, setCalabaza] = React.useState(false);
const [Chile, setChile] = React.useState(false);
const [Tomatillo, setTomatillo] = React.useState(false);

function Tomate_seleccion () {
  setpresentaciones(false);
  setTomate(true);
  setCalabaza(false);
  setChile(false);
  setTomatillo(false);
  const nombrepresentacion= "Tomate";
  actualizarEstadoProductosPresentaciones(nombrepresentacion);
}

function Calabaza_seleccion () {
  setpresentaciones(false);
  setTomate(false);
  setCalabaza(true);
  setChile(false);
  setTomatillo(false);
  const nombrepresentacion= "Calabaza";
  actualizarEstadoProductosPresentaciones(nombrepresentacion);
}

function Chile_seleccion () {
  setpresentaciones(false);
  setTomate(false);
  setCalabaza(false);
  setChile(true);
  setTomatillo(false);
  const nombrepresentacion= "Chile";
  actualizarEstadoProductosPresentaciones(nombrepresentacion);
}

function Tomatillo_seleccion () {
  setpresentaciones(false);
  setTomate(false);
  setCalabaza(false);
  setChile(false);
  setTomatillo(true);
  const nombrepresentacion= "Tomatillo";
  actualizarEstadoProductosPresentaciones(nombrepresentacion);
}

function Reset(){
  setpresentaciones(true);
  setTomate(false);
  setCalabaza(false);
  setChile(false);
  setTomatillo(false);
}

//Para los modales
const [ModalAñadir_presentaciones_productos, setModalAñadir_presentaciones_productos] = React.useState(false);
const [ModalEditar_presentaciones_productos, setModalEditar_presentaciones_productos] = React.useState(false);
const [PALLETS, setPALLETS] = React.useState(false);
const [agregar_precios_pallets, setagregar_precios_pallets] = React.useState(false);
const [ModalDiario, setModalDiario] = React.useState(false);
const [ModalSemanal, setModalSemanal] = React.useState(false);

const [Presentacion, setPresentacion] = React.useState("");
const [ProductosPresentaciones, setProductosPresentaciones] = React.useState([]);
const [Informes, setInformes] = React.useState([]);


function añadirProductoPresentaciones() {
  if(!Tomate){
  }else(
    setPresentacion("Tomate")
  )
  
  if(!Calabaza){
  }else(
    setPresentacion("Calabaza")
  )
  
  if(!Chile){
  }else(
    setPresentacion("Chile")
  )
  
  if(!Tomatillo){
  }else(
    setPresentacion("Tomatillo")
  )
  setModalAñadir_presentaciones_productos(true);
}

//Para actualizar la tabla de las presentaciones
async function actualizarEstadoProductosPresentaciones(nombrepresentacion) {
   await getProductos_presentaciones(nombrepresentacion).then((presentacionesBD) => {
    //Con esto lo ordeno por fechas de forma descendiente
    presentacionesBD.sort((a,b)=>  (b.fecha3) - (a.fecha3));
    setProductosPresentaciones(presentacionesBD);
      console.log(presentacionesBD)
    });
  }

  async function actualizarEstadoProductosPresentaciones2(articulo) {
    await getProductos_presentaciones2(articulo).then((presentacionesBD) => {
     //Con esto lo ordeno por fechas de forma descendiente
     presentacionesBD.sort((a,b)=>  (b.fecha3) - (a.fecha3));
     setProductosPresentaciones(presentacionesBD);
       console.log(presentacionesBD)
     });
   }

  async function eliminar(producto, ProductosPresentaciones){
    const articulo = producto.present;
    var datoeliminado= "";
    ProductosPresentaciones.map((datos)=>{
      if(datos.nombre==producto.nombre){
        datoeliminado = datos;
      }
    })
    await eliminar_presentaciones(datoeliminado, articulo)
    actualizarEstadoProductosPresentaciones2(articulo);
  }

  async function produccion_diaria(){
    await getProductos_presentaciones_diario().then((InformesBD) => {
      setInformes(InformesBD);
      setModalDiario(true);
      console.log(Informes)
      });
  }

  async function produccion_semanal(){
    await getProductos_presentaciones_diario().then((InformesBD) => {
      setInformes(InformesBD);
      setModalSemanal(true);
      console.log(Informes)
      });
  }
//---------------------------------------------------------------

  //console.log("HOME")
  const [productos, setProductos] = React.useState([]);
  const [isModalAñadir, setIsModalAñadir] = React.useState(false);

  const [isModalEditar, setIsModalEditar] = React.useState(false);
  const [productoEditar, setProductoEditar] = React.useState(null);

  const [Embarque_cliente, setEmbarque_cliente] = React.useState(false);

  //Gastos
  const [Gastoson, setGastoson] = React.useState(false);

 async function actualizarEstadoProductos(pagina, start) {
  console.log(pagina)
  if(pagina=="Lineas_produccion")
  {
    setpresentaciones(true);
    setTomate(false);
    setCalabaza(false);
    setChile(false);
    setTomatillo(false);
    //alert("HOla")

  }else{
   await getAllProducts(pagina, start).then((productos) => {
      //Con esto lo ordeno por fechas de forma descendiente
      productos.sort((a,b)=>  (b.fecha3) - (a.fecha3));
      setProductos(productos);
      //console.log(productos);
    });
    }
   if(pagina=="Embarque"){
    if(Manifiestos_pallets){
      console.log("Prueba")
    }else{
    setEmbarque_cliente(true);
    actualizarEstadoManifiestos();
    }
    
   }
   if(pagina=="Gastos indirectos de producción"){
    setGastoson(true);
   }

  }

  function añadirProductoHome() {
    setIsModalAñadir(true);
  }
//EMBARQUE----------------------------------------------------------------------------------------------------
const [isModalClientes, setisModalClientes] = React.useState(false);
const [productos_manifiestos, setproductos_manifiestos] = React.useState(false);

async function actualizarEstadoManifiestos() {
   await getAllmanifiestos().then((ManifiestosDB) => {
    //Con esto lo ordeno por fechas de forma descendiente
    ManifiestosDB.sort((a,b)=>  (b.manifiesto) - (a.manifiesto));
    setproductos_manifiestos(ManifiestosDB);
      console.log(ManifiestosDB);
    });
    }

function Embarque_Modal_clientes(){
  setisModalClientes(true);
}

//Embarque cartera nacional
const [Cartera_nacional, setCartera_nacional] = React.useState(false);

//Embarque cartera exportacion
const [Cartera_exportacion, setCartera_exportacion] = React.useState(false);

//Embarque pallets de manifiestos
const [Manifiestos_pallets, setManifiestos_pallets] = React.useState(false);
const [Manifiestos_pallets_datos, setManifiestos_pallets_datos] = React.useState([]);
const [ModalAñadir_Manifiesto_palletsON, setModalAñadir_Manifiesto_palletsON] = React.useState(false);
const [ModalAñadir_Manifiesto_facturas, setModalAñadir_Manifiesto_facturasON] = React.useState(false);
const [Manifiesto_Seleccionado, setManifiesto_Seleccionado] = React.useState([]);


async function EmbarqueOFF(producto){
  setEmbarque_cliente(false);
  setManifiestos_pallets(true);
  setManifiesto_Seleccionado(producto);
  Pallets(producto);
}

//Con esto traes los pallet que tiene actualmente el manifiesto seleccionado
async function Pallets(producto){
  await getAllPallets(producto).then((PalletsDB) => {
    setManifiestos_pallets_datos(PalletsDB);
    setManifiestos_pallets(true);
    console.log(PalletsDB);
    });
}

//Eliminar con sweetalert2
function eliminar_sweetalert2(producto) {
  Swal.fire({
    title: '¿Esta seguro de eliminar el pallet?  "'+ producto.tarima_seleccionada+'"',
    text: "Esta acción no se puede restablecer!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si, eliminar.'
  }).then((result) => {
    if (result.isConfirmed) {
      Swal.fire(
        'Eliminado!',
        'El pallet ha sido eliminado.',
        'success'
      )
     eliminar_tarimas_de_manifiesto(producto)
    }
  })
}


//Eliminar con sweetalert2
function eliminar_sweetalert3(producto, ProductosPresentaciones) {
  Swal.fire({
    title: '¿Esta seguro de eliminar "'+ producto.nombre+'" ?',
    text: "Esta acción no se puede restablecer!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si, eliminar.'
  }).then((result) => {
    if (result.isConfirmed) {
      eliminarAlmacen_empaque_carton_KGCULTIVO(producto).then(
        (confirmacion) => {
          var articulo = producto.present;
          actualizarEstadoProductosPresentaciones2(articulo);
          Swal.fire(
            'Eliminado!',
            'Ha sido eliminada.',
            'success'
          )
        }
      );

    }
  })
}

//Eliminar con sweetalert2
function eliminar_botones_consumibles_mano_de_obre_etc(producto, pagina) {
  Swal.fire({
    title: '¿Esta seguro de eliminar "'+ producto.nombre+'" ?',
    text: "Esta acción no se puede restablecer!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si, eliminar.'
  }).then((result) => {
    if (result.isConfirmed) {
      eliminarProductoHome(producto, pagina).then(
        (confirmacion) => {
          actualizarEstadoProductos(pagina, start);
          Swal.fire(
            'Eliminado!',
            'Ha sido eliminada.',
            'success'
          )
        }
      );

    }
  })
}

//Eliminar  tarimas_de_manifiesto
async function eliminar_tarimas_de_manifiesto(producto){
  var Manifiesto_Seleccionado = producto;
  await getLugares_caja(Manifiesto_Seleccionado).then((Lugar_cajaDB) => {
    console.log(Lugar_cajaDB[0]);
       restar_tarimas(producto, Lugar_cajaDB);
    });
}

async function restar_tarimas(producto, Lugar_cajaDB){
  await getProductos_empaque().then((productos2) => {
   var cantidad_actual=0; 
      productos2.map((dato)=>{
        //console.log(dato.nombre, producto.tarima_seleccionada)
        if(dato.nombre==producto.tarima_seleccionada){
          cantidad_actual= dato.cantidad;
        }
      })

      eliminarManifiesto_tarima(producto, Lugar_cajaDB[0], cantidad_actual).then(
        (confirmacion) => {
          Pallets(producto);
        }
      );

    });
}

/* Pallets(producto); */


//------------------------------------------------------------------------------------------------------------
//Gastos

//Gastos indirectos de produccion------------------------------------------------------------
const [Gastos_LOGS, setGastos_LOGS] = React.useState([]);
const [gastos_totales_final, setgastos_totales_final] = React.useState(0);

async function actualizar_datos_gastos() {
  await getProductos_gastos().then((GastosDB) => {
     setGastos_LOGS(GastosDB);
     console.log(GastosDB);
     Gastos(GastosDB);
   });
 }

 function Gastos(GastosDB){
var gastos_total=0;
  GastosDB.map((datos)=>{
    var sumar=0;
    if(datos.Seccion=="Gastos indirectos de producción"){
      sumar=parseInt(datos.Precio)*parseInt(datos.Cantidad_retirada);
      gastos_total=gastos_total+sumar;
    }
  })
Guardar_total_gastos(gastos_total);
 }

function Guardar_total_gastos(gastos_total){
  const dato = parseInt(gastos_total);
    var costo= {
      valor: dato,
      nombre: "Gastos indirectos de producción empaque",
      };
  añadir_total_gastos(gastos_total,costo);
  setgastos_totales_final(gastos_total);
}
//--------------------------------------------------------------------------------------------
//---------------------------------------PDF--------------------------------------------------
//Con este me traego los lugares en el trailer del manifiesto seleccionado
async function pdfGenerate1(producto){
  console.log(producto)
  await getManifiesto_lugares_caja(producto).then((Lugares_manifiestoDB) => {
    pdfGenerate2(producto, Lugares_manifiestoDB)
  })
}

async function pdfGenerate2(producto, Lugares_manifiestoDB){
  await getClientes_Embarque().then((clientesDB) => {
    pdfGenerate3(producto, Lugares_manifiestoDB, clientesDB)
  })
}



async function pdfGenerate3( producto, Lugares_manifiestoDB, clientesDB){
  console.log(producto);
  //console.log(clientesDB);
  var Cliente_seleccionado_manifiesto= [];
  clientesDB.map((Cliente_ok)=>{
    if(Cliente_ok.nombre==producto.cliente){
      Cliente_seleccionado_manifiesto.push(Cliente_ok);
    }
  })
  
  //CREAR PDF DE MANIFIESTO
  await getProductos_manifiesto(producto).then((productos_manifiestoDB) => {
    console.log(productos_manifiestoDB);
   //landscape es horizontal la pagina y portrait vertical
   var doc=new jsPDF('portrait', 'px', 'a4', 'false');
  var imgData="data:image/jpeg;base64,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"
   doc.addImage(imgData,30,1,90,70);
   //Agrega pagina tipo a4 y vertical por le portrait
   //doc.addPage("a4", "portrait")
   //Agrega texto el primer dato es posicion horizontal el segundo vertical}
   doc.setFontSize(7);
   doc.text("CLIENTE: ", 10,80);           doc.text(""+Cliente_seleccionado_manifiesto[0].nombre, 85,80)
   doc.text("DIRECCIÓN: ", 10,86);         doc.text(""+Cliente_seleccionado_manifiesto[0].direccion, 85,86)
   doc.text("CIUDAD: ", 10,92);            doc.text(""+Cliente_seleccionado_manifiesto[0].ciudad, 85,92)
   doc.text("RFC: ", 10,98);               doc.text(""+Cliente_seleccionado_manifiesto[0].rfc, 85,98)
   doc.text("DATOS TRANSPORTE: ", 10,114); doc.text(""+producto.datos_transporte, 85,114)
   doc.text("NOMBRE DE CHOFER: ", 10,120); doc.text(""+producto.chofer, 85,120)
   doc.text("PLACAS CAMIÓN: ", 10,126);    doc.text(""+producto.placas, 85,126)
   doc.text("NO. CAJA: ", 10,132);         doc.text(""+producto.caja, 85,132)
   doc.text("PLACAS CAJA: ", 10,138);      doc.text(""+producto.placas_caja, 85,138)
   doc.text("TELEFONO: ", 10,144);         doc.text(""+producto.celular, 85,144)
   doc.text("FLETE: ", 10,150);            doc.text(""+formatter.format(producto.total_flete), 85,150)
   doc.text("TEMP. F: ", 10,156);          doc.text(""+producto.tem_f, 85,156)

   if(producto.nacional_exportacion2=="Exportación"){
    doc.text("SCAC: ", 10,162);                 doc.text(""+producto.scac, 85,162)
    doc.text("ID TRIB: ", 10,104);              doc.text(""+producto.id_trib, 85,104)
    doc.text("FECHA DE SALIDA: ", 290,80);      doc.text(""+producto.fecha_salida, 375,80)
    doc.text("HORA DE SALIDA: ", 290,86);       doc.text(""+producto.hora_salida, 375,86)
    doc.text("MANIFIESTO: ", 290,92);           doc.text(""+producto.manifiesto, 375,92)
    doc.text("FACTURA: ", 290,98);              doc.text(""+producto.factura, 375,98)
    doc.text("AGENCIA ADUANAL MX: ", 290,150);  doc.text(""+producto.agencia_aduanal_mx, 375,150)
    doc.text("AGENCIA ADUANAL USA: ", 290,156); doc.text(""+producto.agencia_aduanal_usa, 375,156)
    doc.text("PEDIMIENTO SEMANAL: ", 290,162);  doc.text("00"+producto.pedimiento_semanal, 375,162)

   }else{
    doc.text("FECHA DE SALIDA: ", 290,80);         doc.text(""+producto.fecha_salida, 360,80)
    doc.text("HORA DE SALIDA: ", 290,86);          doc.text(""+producto.hora_salida, 360,86)
    doc.text("MANIFIESTO: ", 290,92);              doc.text("N"+producto.manifiesto, 360,92)
    //doc.text("FACTURA: ", 290,118);            doc.text(""+producto.factura, 360,118)
    //doc.text("EMBARQUE: ", 270,124);          doc.text(""+producto.embarque, 360,124)
   }

   doc.setFontSize(18);
   doc.text("HORTICOLA LUIPACK, SPR DE RL", 150 ,15)
   doc.setFontSize(6);
   doc.text("BLVD EMILIANO ZAPATA NO. 804 PTE", 165 ,23)
   doc.text("PUEBLO YAQUI, SONORA MEXICO CP 85200", 248,23)
   doc.text("EMAIL: MANIFIESTOSHORTICOLA@GMAIL.COM", 205 ,28)
   doc.text("RFC: HLS-970821-NB0", 175 ,33)
   doc.text("TEL: + 52 (643) 4371010", 231,33)
   doc.text("FDA: 19991703164", 290,33)

   doc.setFontSize(13);
   doc.text("MANIFIESTO DE EMBARQUE", 190,50)
   doc.text("_________________________", 190,51)
   doc.setFontSize(11);
   doc.text("PRODUCTO DE MÉXICO", 205,62)

//Tabla 1 posiciones de pallets en el trailer
var inicio_Y = 165;

//var auxiliar1 = Lugares_manifiestoDB[0].lugar_caja_vacio[6].nombre_producto;

var columns = [
  { title: "MAPA DE", dataKey: "nombre_producto", halign: 'center'},
 ];
//console.log(Lugares_manifiestoDB)
var prueba = [
  Lugares_manifiestoDB[0].lugar_caja_vacio[1],
  Lugares_manifiestoDB[0].lugar_caja_vacio[3],
  Lugares_manifiestoDB[0].lugar_caja_vacio[5],
  Lugares_manifiestoDB[0].lugar_caja_vacio[7],
  Lugares_manifiestoDB[0].lugar_caja_vacio[9],
  Lugares_manifiestoDB[0].lugar_caja_vacio[11],
  Lugares_manifiestoDB[0].lugar_caja_vacio[13],
  Lugares_manifiestoDB[0].lugar_caja_vacio[15],
  Lugares_manifiestoDB[0].lugar_caja_vacio[17],
  Lugares_manifiestoDB[0].lugar_caja_vacio[19],
  Lugares_manifiestoDB[0].lugar_caja_vacio[21],
  Lugares_manifiestoDB[0].lugar_caja_vacio[23],
  Lugares_manifiestoDB[0].lugar_caja_vacio[25],
] 
var rows = 
  prueba
;
var ancho_celda = 60; 
var alto_celda = 22; 
console.log(Lugares_manifiestoDB)
doc.autoTable(columns, rows, {
  startY: inicio_Y,
  margin: { horizontal: 10 },
  styles: { overflow: 'linebreak' },
  bodyStyles: { valign: 'top' }, 
  fontSize: 6,
  columnStyles: {
   0:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda},
  },
  theme: "grid"
});

 columns = [
  {title: "CARGA", dataKey: "nombre_producto", halign: 'center' },
 ];
 
 var prueba2 = [
  Lugares_manifiestoDB[0].lugar_caja_vacio[2],
  Lugares_manifiestoDB[0].lugar_caja_vacio[4],
  Lugares_manifiestoDB[0].lugar_caja_vacio[6],
  Lugares_manifiestoDB[0].lugar_caja_vacio[8],
  Lugares_manifiestoDB[0].lugar_caja_vacio[10],
  Lugares_manifiestoDB[0].lugar_caja_vacio[12],
  Lugares_manifiestoDB[0].lugar_caja_vacio[14],
  Lugares_manifiestoDB[0].lugar_caja_vacio[16],
  Lugares_manifiestoDB[0].lugar_caja_vacio[18],
  Lugares_manifiestoDB[0].lugar_caja_vacio[20],
  Lugares_manifiestoDB[0].lugar_caja_vacio[22],
  Lugares_manifiestoDB[0].lugar_caja_vacio[24],
  Lugares_manifiestoDB[0].lugar_caja_vacio[26],
] 

 rows = 
  prueba2
;
doc.autoTable(columns, rows, {
  startY: inicio_Y,
  margin: { horizontal: 70 },
  styles: { overflow: 'linebreak' },
  bodyStyles: { valign: 'top' },
  fontSize: 6,
  columnStyles: {
    0:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda}, 
  },
  theme: "grid"
});

//Tabla 2 productos--------------------------------------------------------------------------------------

//Prueba de separar por categorias y crear tablas por cada categoria----------------------------------------------------------
//Con estos map consigo todos los tipos diferentes de pallets que se ingresaron sin repetir y se guarda en productos_resultados-----------------
var productos_resultados = [];
productos_manifiestoDB.map((dato, auxiliar)=>{
var auxiliar100 = false;  
 //Con este if me aseguro que el primer dato se mande directo ya que esta vacio el arreglo 
        if(auxiliar==0){
          //dato['Resultado_pallets']= dato.cantidad_retirada;
        }else{
        //Con este map comparo si ya existe en el arreglo creado el producto que se esta analizando y si ya existe solo se suma la cantidad si no se agrega directo
        productos_resultados.map((valor)=>{
            if(dato.categoria_pallet==valor.categoria_pallet){
              auxiliar100 = true;
              //auxiliar101 = valor;
            }
          })//Fin segundo map
        }//Fin else del primer if

  if(auxiliar100==true){

  }else{
    productos_resultados.push(dato);
  }
})//Fin primer map



//Con esto agrego lo de las facturas, se pone aqui porque ocupo primero saber las categorias que tengo y aqui se hace---------------------
    var auxiliar_posicion_en_y_para_facturas = 104;
    var auxiliar_facturas = producto.total_facturas_manifiesto;
    var prueba5 = 0;
    //Esto es para agregar las facturas de las categorias que hay en el manifiesto
    if(auxiliar_facturas == undefined){

    }else{
      var total_facturas = 0;
          auxiliar_facturas.map((valor5, auxiliar)=>{ 
      const auxiliar5 = valor5; 
        productos_resultados.map((valor6, auxiliar)=>{
              if(auxiliar5[valor6.categoria_pallet] !== undefined){
                console.log(parseInt(auxiliar_posicion_en_y_para_facturas +prueba5))
                doc.setFontSize(7);
                doc.text("Factura de "+valor6.categoria_pallet, 290, parseInt(auxiliar_posicion_en_y_para_facturas +prueba5));  
                doc.text(formatter.format(auxiliar5[valor6.categoria_pallet]), 375, parseInt(auxiliar_posicion_en_y_para_facturas +prueba5));
                prueba5 = parseInt(prueba5 + 6)
                total_facturas = parseInt(total_facturas) + +parseInt(auxiliar5[valor6.categoria_pallet]);
              }
           })
        })
        //Aqui agrego el total de las facturas
        doc.text("Total facturas: ", 290, parseInt(auxiliar_posicion_en_y_para_facturas +prueba5)); 
        doc.text(formatter.format(total_facturas), 375, parseInt(auxiliar_posicion_en_y_para_facturas +prueba5));
    }


 //------------------------------------- ------------------------------------------------------------------------------------------------




//Contenido de tablas--------------------------------------------------------------------------------------------------------------
//La ubicacion en Y de la primera tabla se pone por fuera del map, las demas posiciones en Y seran dinamicas acorde donde terminen las tablas
var posicion_en_Y = 165;
//van a dentro de un map para generar la cantidad de tablas segun la cantidad de tipos de pallets que hay en el manifiesto 
//Map principal
productos_resultados.map((tablas_auxiliar)=>{
          //Primero separar todos los productos del manifiesto a la categoria actual que va en el map
            var auxiliar111 = [];
            productos_manifiestoDB.map((auxiliar222)=>{
              if(tablas_auxiliar.categoria_pallet == auxiliar222.categoria_pallet ){
                auxiliar111.push(auxiliar222);
              }
            })

          //Calcular total kilo y total cantidad de cada pallet ya separado por categoria
            auxiliar111.map((valor_total)=>{
              if(valor_total.cajas_por_pallet_1 !== undefined){
                var auxiliar2000 = (valor_total.kilos_por_cajas_por_pallet_1) * (valor_total.cajas_por_pallet_1);
                var auxiliar2001 = (valor_total.kilos_por_cajas_por_pallet_2) * (valor_total.cajas_por_pallet_2);
                var total = parseInt(auxiliar2000) + +parseInt(auxiliar2001);
                valor_total['total_kilos'] = new Intl.NumberFormat('es-MX').format(total.toFixed(2));
                
                var total_cantidad =(valor_total.cajas_por_pallet) * (valor_total.cantidad_retirada);
                //valor_total['total_cantidad'] = new Intl.NumberFormat('es-MX').format(total_cantidad.toFixed(2)); 
                //Con este pongo el nombre de los dos productos que hacen la tarima conbinada
                valor_total['tarima_seleccionada'] = valor_total.tarima_seleccionada_1 + "\n" + valor_total.tarima_seleccionada_2; 

                //Con este pongo las cajas de los dos productos por separado que hacen la tarima conbinada
                valor_total['total_cantidad'] = valor_total.cajas_por_pallet_1 + "\n" + valor_total.cajas_por_pallet_2; 

              }else{
                var total = (valor_total.kilos_por_cajas_por_pallet) * (valor_total.cajas_por_pallet) * (valor_total.cantidad_retirada);
                valor_total['total_kilos'] = new Intl.NumberFormat('es-MX').format(total.toFixed(2));
                
                var total_cantidad =(valor_total.cajas_por_pallet) * (valor_total.cantidad_retirada);
                valor_total['total_cantidad'] = new Intl.NumberFormat('es-MX').format(total_cantidad.toFixed(2)); 
              }

            })

          var nombre_tabla = [tablas_auxiliar.categoria_pallet];
          var columns = [
          // { title: "Caja KG", dataKey: "kilos_por_cajas_por_pallet", halign: 'center' }, 
            { cellWidth: 190, title: (nombre_tabla), dataKey: "tarima_seleccionada", halign: 'center' },
            { cellWidth: 30, title: "Pallets", dataKey: "cantidad_retirada", halign: 'center' },
            { cellWidth: 30, title: "Cajas", dataKey: "total_cantidad", halign: 'center' },
            { cellWidth: 30, title: "Kilos", dataKey: "total_kilos", halign: 'center' },
          ];

          //Con esto le agrego la fila del TOTAL
          //productos_manifiestoDB.push("Total");
          //console.log(productos_manifiestoDB);
          //console.log(productos_manifiestoDB.length)
          var rows = 
            auxiliar111
          ;
             
         var alto_celda2 = 10; 
         var ancho_celda = 30; 

          doc.autoTable(columns, rows, {
            startY: posicion_en_Y,
            margin: { horizontal: 137 },
            //styles: { overflow: 'linebreak', fillColor:[0,0,0] }, Si le agrego fill color coloreo el fonde de toda la tabla
            styles: { overflow: 'linebreak'},
            bodyStyles: { valign: 'top' },
            fontSize: 7,
            columnStyles: {
            0:{cellWidth:190, halign: 'center', minCellHeight: alto_celda2},
            1:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda2}, 
            2:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda2},
            3:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda2},
            4:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda2},
            },
            theme: "grid"
          }); 

         posicion_en_Y = parseInt(posicion_en_Y+9)+ parseInt((auxiliar111.length+1)*(13.5));
    })



/*  productos_manifiestoDB.map((valor_total)=>{
      var total = (valor_total.kilos_por_cajas_por_pallet) * (valor_total.cajas_por_pallet) * (valor_total.cantidad_retirada);
      valor_total['total_kilos'] = total.toFixed(2);

      var total_cantidad =(valor_total.cajas_por_pallet) * (valor_total.cantidad_retirada);
      valor_total['total_cantidad'] = total_cantidad.toFixed(2);
    })


  var columns = [
   // { title: "Caja KG", dataKey: "kilos_por_cajas_por_pallet", halign: 'center' }, 
    { cellWidth: 190, title: "Producto", dataKey: "tarima_seleccionada", halign: 'center' },
    { cellWidth: 30, title: "Pallets", dataKey: "cantidad_retirada", halign: 'center' },
    { cellWidth: 30, title: "Cajas", dataKey: "total_cantidad", halign: 'center' },
    { cellWidth: 30, title: "Kilos", dataKey: "total_kilos", halign: 'center' },
   ];

  //Con esto le agrego la fila del TOTAL
  //productos_manifiestoDB.push("Total");
  console.log(productos_manifiestoDB);
  console.log(productos_manifiestoDB.length)
  var rows = 
    productos_manifiestoDB
  ;

 var posicion_en_Y = 165; 
 var  alto_celda2 = 10; 
 var ancho_celda = 30; 
  doc.autoTable(columns, rows, {
    startY: posicion_en_Y,
    margin: { horizontal: 137 },
    //styles: { overflow: 'linebreak', fillColor:[0,0,0] }, Si le agrego fill color coloreo el fonde de toda la tabla
    styles: { overflow: 'linebreak'},
    bodyStyles: { valign: 'top' },
    fontSize: 7,
    columnStyles: {
     0:{cellWidth:190, halign: 'center', minCellHeight: alto_celda2},
     1:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda2}, 
     2:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda2},
     3:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda2},
     4:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda2},
    },
    theme: "grid"
  }); */

//FIRMA DEL CHOFER-----------------------------------------------------------------
 var posicion_vertical = 505;

   doc.setFontSize(8);
   /* doc.text("OK:", 10 ,posicion_vertical+10); doc.text("________", 70 ,posicion_vertical+10);
   doc.text("Comentarios:", 10 ,posicion_vertical+20); doc.text("_________________", 70 ,posicion_vertical+20);
   doc.text("Discrepancias:", 10 ,posicion_vertical+30); doc.text("_________________", 70 ,posicion_vertical+30) 
   doc.text("_____________________________________________________", 30 ,posicion_vertical+80)
   doc.text("Responsable", 103 ,posicion_vertical+90)
   doc.text("Nombre y Firma", 100 ,posicion_vertical+100)*/
   doc.text("_____________________________________________________", 230 ,posicion_vertical+80)
   doc.text("Chofer", 312 ,posicion_vertical+90)
   doc.text("Nombre y Firma", 300 ,posicion_vertical+100)


//Tabla de resultados del manifiesto-------------------------------------------

//------------------------------------------------------------------------------------------------------------------------------------------------
//Con estos maps sumo la cantidad de pallets de cada tipo de pallet-------------------------------------------------------------------------------
productos_resultados.map((dato2)=>{
    productos_manifiestoDB.map((valor2)=>{
      if(dato2.categoria_pallet==valor2.categoria_pallet){
        if(dato2.Resultado_pallets==undefined){
          dato2['Resultado_pallets']= parseInt(valor2.cantidad_retirada);
        }else{
          dato2['Resultado_pallets']= parseInt(dato2.Resultado_pallets) + parseInt(valor2.cantidad_retirada);
        }
      }
    })//Fin segundo map
})//Fin primer map
//------------------------------------------------------------------------------------------------------------------------------------------------
//Con este map le agrego los resultados de cajas total de cada pallet y resultado de kg
productos_resultados.map((dato3)=>{
 
  dato3['Resultado_cajas'] = 0;
  dato3['Resultado_kg'] = 0;

  productos_manifiestoDB.map((valor3)=>{
    if(dato3.categoria_pallet==valor3.categoria_pallet){

        var total_cajas = (valor3.cajas_por_pallet) * (valor3.cantidad_retirada);
        dato3['Resultado_cajas'] = parseInt(dato3.Resultado_cajas) + parseInt(total_cajas);

        if(valor3.cajas_por_pallet_1 !== undefined){//Si es conbinado hace esto
          var auxiliar2006 = (valor3.kilos_por_cajas_por_pallet_1) * (valor3.cajas_por_pallet_1);
          var auxiliar2007 = (valor3.kilos_por_cajas_por_pallet_2) * (valor3.cajas_por_pallet_2);
          var total_KG = parseInt(auxiliar2006) + +parseInt(auxiliar2007);
          
          var auxiliar1000 = formatter.format(+(parseInt(dato3.Resultado_kg)) + +parseInt(total_KG));
          const str = (auxiliar1000).toString();
          //Con esto le quito el signo de $ y con los otros le quito 3 comas a la cantidad
          const nuevaStr = str.replace("$", "");
          const nuevaStr2 = nuevaStr.replace(",", "");
          const nuevaStr3 = nuevaStr2.replace(",", "");
          const auxiliar11 = nuevaStr3.replace(",", "");
          
          dato3['Resultado_kg'] = auxiliar11;
        }else{ //Si no es conbinado hace esto
          var total_KG = (valor3.cajas_por_pallet) * (valor3.kilos_por_cajas_por_pallet) * (valor3.cantidad_retirada);
          var auxiliar1000 = formatter.format(+(parseInt(dato3.Resultado_kg)) + +parseInt(total_KG));
          const str = (auxiliar1000).toString();
          //Con esto le quito el signo de $ y con los otros le quito 3 comas a la cantidad
          const nuevaStr = str.replace("$", "");
          const nuevaStr2 = nuevaStr.replace(",", "");
          const nuevaStr3 = nuevaStr2.replace(",", "");
          const auxiliar11 = nuevaStr3.replace(",", "");
          
          dato3['Resultado_kg'] = auxiliar11;
        }
    }
  })//Fin segundo map
})//Fin primer map

//Con este map convierto el formato de resultado cajas y kg a millares con el numberformat
productos_resultados.map((dato33)=>{
  dato33['Resultado_cajas'] = new Intl.NumberFormat('es-MX').format(parseInt(dato33.Resultado_cajas).toFixed(2)); ;
  dato33['Resultado_kg'] = new Intl.NumberFormat('es-MX').format(parseInt(dato33.Resultado_kg).toFixed(2)); 

})//Fin primer map
//productos_resultados----------------------------------------------------------------------------------------------------------------------------
//Aqui se agrega el renglón para el total a la tabla--------------------------------------------------------------------------------------
var Resultado_Total_pallets = 0;
var Resultado_Total_cajas = 0;
var Resultado_Total_kg = 0;

productos_resultados.map((dato4)=>{
  console.log(Resultado_Total_kg,dato4.Resultado_kg )
  Resultado_Total_pallets = parseFloat(Resultado_Total_pallets) + +parseFloat(dato4.Resultado_pallets);

        //Con esto le quito el signo de $ y con los otros le quito 3 comas a la cantidad de cajas
        const strr = (dato4.Resultado_cajas).toString();
        const nuevaStrr = strr.replace("$", "");
        const nuevaStr22 = nuevaStrr.replace(",", "");
        const nuevaStr33 = nuevaStr22.replace(",", "");
        const auxiliar111 = nuevaStr33.replace(",", "");
        Resultado_Total_cajas = (parseInt(Resultado_Total_cajas)) + +parseInt(auxiliar111);


        //Con esto le quito el signo de $ y con los otros le quito 3 comas a la cantidad de KG
        const str = (dato4.Resultado_kg).toString();
        const nuevaStr = str.replace("$", "");
        const nuevaStr2 = nuevaStr.replace(",", "");
        const nuevaStr3 = nuevaStr2.replace(",", "");
        const auxiliar11 = nuevaStr3.replace(",", "");
        Resultado_Total_kg = (parseInt(Resultado_Total_kg)) + +parseInt(auxiliar11);
})

var auxiliar_final= {"categoria_pallet": "TOTAL",
  "Resultado_pallets": new Intl.NumberFormat('es-MX').format(parseInt(Resultado_Total_pallets)), 
  "Resultado_cajas": new Intl.NumberFormat('es-MX').format(parseInt(Resultado_Total_cajas)), 
  "Resultado_kg": new Intl.NumberFormat('es-MX').format(parseInt(Resultado_Total_kg))};

productos_resultados.push(auxiliar_final);
//------------------------------------------------------------------------------------------------------
var columns = [
  { title: "Resumen de carga", dataKey: "categoria_pallet", halign: 'center' },
  { title: "Pallets", dataKey: "Resultado_pallets", halign: 'center' },
  { title: "Cajas", dataKey: "Resultado_cajas", halign: 'center' },
  { title: "KG", dataKey: "Resultado_kg", halign: 'center' },
 ];

var rows = 
  productos_resultados
; 

//Con este que esta comentado se posiciona en automatico debajo de la tabla 2 que es la de producttos pero
//se deja fuera para dejarla debajo de la table de las posiciones del trailer por peticion
/* var posicionY_total = parseInt(posicion_en_Y+5)+ parseInt((productos_manifiestoDB.length+1)*(13.5)); */

var posicionY_total = parseInt(470)
var alto_celda5 = 10;
doc.autoTable(columns, rows, {
  startY: posicionY_total,
  margin: { horizontal: 10 }, 
  styles: { overflow: 'linebreak'},
  bodyStyles: { valign: 'top' },
  fontSize: 7,
  columnStyles: {
   0:{cellWidth: 100, halign: 'center', minCellHeight: alto_celda5},
   1:{cellWidth: 30, halign: 'center', minCellHeight: alto_celda5}, 
   2:{cellWidth: 30, halign: 'center', minCellHeight: alto_celda5},
   3:{cellWidth: 35, halign: 'center', minCellHeight: alto_celda5},
  },
  theme: "grid"
});
//------------------------------------------------------------------------------------------------------


//Tabla de clave SAT y fraccion arrancelaria de los productos-------------------------------------------

/* var columns = [
  { title: "Producto", dataKey: "PRODUCTO", halign: 'center' },
  { title: "Clave producto SAT", dataKey: "SAT", halign: 'center' },
  { title: "Fracción arrancelaria", dataKey: "FRACCION", halign: 'center' },
 ];

var productos = [
  {PRODUCTO: "TOMATILLO", SAT: "50405104", FRACCION: "0702000302"},
  {PRODUCTO: "CALABAZA", SAT: "50403900", FRACCION: "1209911507"},
  {PRODUCTO: "CHILE JALAPEÑO", SAT: "50405625", FRACCION: "0709600203"},
  {PRODUCTO: "CHILE ANAHEIM", SAT: "50405613", FRACCION: "0709600203"},
  {PRODUCTO: "TOMATE", SAT: "50406500", FRACCION: "0702000304"},
]

var rows = 
  productos
;
ancho_celda = 60; 
alto_celda = 4;
doc.autoTable(columns, rows, {
  startY: 145,
  margin: { horizontal: 230 },
  //styles: { overflow: 'linebreak', fillColor:[0,0,0] }, Si le agrego fill color coloreo el fonde de toda la tabla
  styles: { overflow: 'linebreak'},
  bodyStyles: { valign: 'top' },
  fontSize: 7,
  columnStyles: {
   0:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda},
   1:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda}, 
   2:{cellWidth: ancho_celda, halign: 'center', minCellHeight: alto_celda},
  },
  theme: "grid"
}); */
//------------------------------------------------------------------------------------------------------


  


   if(producto.nacional_exportacion2=="Exportación"){
    doc.save('Manifiesto '+producto.manifiesto+'.pdf')
   }else{
    doc.save('Manifiesto N'+producto.manifiesto+'.pdf')
   }
   
   //doc.save('Orden '+valor+'.pdf')

  });

  
}


//--------------------------------------------------------------------------------------------

  React.useEffect(() => {
    actualizarEstadoProductos(pagina, start);
    usuario_actual();
  }, []);

  return (
<div id="Tablas_blanco">
    
<Navbartrabajo/>

{/* Este sirve para abrir la tabla donde no se seleccione linea de produccion */}
{presentaciones || Tomate || Calabaza || Chile || Tomatillo || Embarque_cliente || Manifiestos_pallets? 
null
:
<div>
     <Container fluid id="Navbar_trabajo_home">
      {isModalAñadir && (
      <ModalAñadir
        isModalAñadir={isModalAñadir}
        setIsModalAñadir={setIsModalAñadir}
        actualizarEstadoProductos={actualizarEstadoProductos}
        usuario={usuario}
        pagina={pagina}
        start={start}
        setProductos={setProductos}
        Embarque_cliente={Embarque_cliente}
        Gastoson={Gastoson}
      />)}
      {productoEditar && (
        <ModalEditar
          isModalEditar={isModalEditar}
          setIsModalEditar={setIsModalEditar}
          actualizarEstadoProductos={actualizarEstadoProductos}
          productoEditar={productoEditar}
          setProductoEditar={setProductoEditar}
          usuario={usuario}
          pagina={pagina}
          start={start}
        />
      )}
      <br/>
      <Stack direction="horizontal" className="justify-content-between">
        <p style={{ fontSize: 20 }}>Bienvenido {usuario.email}, Actualmente estas en {window.location.pathname} de la sección {pagina}</p>
        <Button onClick={añadirProductoHome}> Retirar Producto</Button>
        <Button id="boton_regresar_ordenes" onClick={()=>{Pagina_principal()}}> Regresar</Button>
        <Button onClick={signOut}>Cerrar sesión</Button>
      </Stack>
      {Gastoson &&(
      <div>
        <hr />
        <Stack direction="horizontal" className="justify-content-between">
              <p style={{ fontSize: 16, marginLeft: "20%"  }}>Gastos totales indirectos del empaque {gastos_totales_final} MXN</p>
              <Button style={{ marginRight: "30%" }} onClick={() => {actualizar_datos_gastos()}}>Guardar</Button>        
        </Stack>
      </div>
      )}
      <hr />
      
      <Table>
        <thead>
          <tr>
            <th>#</th>
            <th>Fecha</th>
            <th>Producto</th>
            <th>Cantidad</th>
            <th>Unidad</th>
            <th>Línea</th>
            <th>Usuario</th>
            {Embarque_cliente &&
             <th>Cliente</th>
            }
             <th>Acciones</th> 
          </tr>
        </thead>
        <tbody>
          {productos &&
            productos.map((producto, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{producto.fecha}</td>
                <td>{producto.nombre}</td>
                <td>{producto.cantidad}</td>
                <td>{producto.unidad}</td>
                <td>{producto.linea}</td>
                <td>{producto.usuario2}</td>
                {Embarque_cliente &&
                <td>{producto.cliente}</td>
                }
                <td>
                  {/* <Button
                    variant="dark"
                    onClick={() => {
                      setProductoEditar({ ...producto });
                      setIsModalEditar(true);
                    }}
                  >
                    Editar
                  </Button> */}
                   <Button
                    variant="danger"
                    onClick={() => {
                      eliminar_botones_consumibles_mano_de_obre_etc(producto, pagina)
                    }}
                  >
                    Eliminar
                  </Button> 
                  {/* <Button
                    variant="success"
                    onClick={() => {
                      Historial(pagina);
                    }}
                  >
                    Historial
                  </Button> */}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      <Button onClick={añadirProductoHome}> Retirar Producto</Button>
      <Button id="boton_regresar_ordenes" onClick={()=>{Pagina_principal()}}> Regresar</Button>
      <br/>
      <br/>
    </Container>
</div>  
}

{/* Este sirve por si se elige linea de produccion */}
{Tomate || Calabaza || Chile || Tomatillo? 
  <div>
    <Container fluid id="Navbar_trabajo_home">

    {ModalAñadir_presentaciones_productos && (
      <ModalAñadir_presentaciones
        ModalAñadir_presentaciones_productos={ModalAñadir_presentaciones_productos}
        setModalAñadir_presentaciones_productos={setModalAñadir_presentaciones_productos}
        actualizarEstadoProductos={actualizarEstadoProductos}
        usuario={usuario}
        pagina={pagina}
        start={start}
        Presentacion={Presentacion}
        setProductosPresentaciones={setProductosPresentaciones}
        ProductosPresentaciones={ProductosPresentaciones}
      />
    )}  
      {ModalEditar_presentaciones_productos? 
        <ModalEditar_presentaciones
        ModalEditar_presentaciones_productos={ModalEditar_presentaciones_productos}
        setModalEditar_presentaciones_productos={setModalEditar_presentaciones_productos}
        actualizarEstadoProductos={actualizarEstadoProductos}
        productoEditar={productoEditar}
        setProductoEditar={setProductoEditar}
        usuario={usuario}
        pagina={pagina}
        start={start}
        Presentacion={Presentacion}
      />
      :null
      }

      <Stack direction="horizontal" className="justify-content-between">
        <p style={{ fontSize: 20 }}>Bienvenido {usuario.email}, Actualmente estas en {window.location.pathname} de la sección {pagina}</p>
        <Button onClick={añadirProductoPresentaciones}> Agregar caja</Button>
        <Button id="boton_regresar_ordenes" onClick={()=>{Reset()}}> Regresar</Button>
        <Button onClick={signOut}>Cerrar sesión</Button>
      </Stack>

      <hr />
      
      <Table>
        <thead>
          <tr>
            {/* <th>#</th> */}
            <th>Fecha</th>
            <th>Producto</th>
            <th>Cantidad</th>
            {/* <th>Unidad</th> */}
            <th>Usuario</th>
            <th>Movimiento</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {ProductosPresentaciones &&
            ProductosPresentaciones.map((producto, index) => (
              <tr key={index}>
                {/* <td>{index + 1}</td> */}
                <td>{producto.fecha}</td>
                <td>{producto.nombre}</td>
                <td>{producto.cantidad}</td>
                {/* <td>{producto.unidad}</td> */}
                <td>{producto.usuario2}</td>
                <td>{producto.Movimiento}</td>
                <td>
                  {/* <Button
                    variant="dark"
                    onClick={() => {
                      setProductoEditar({ ...producto });
                      setModalEditar_presentaciones_productos(true);
                    }}
                  >
                    Editar
                  </Button> */}
                   <Button
                    variant="danger"
                    onClick={() => {
                      eliminar_sweetalert3(producto, ProductosPresentaciones)
                    }}
                  >
                    Eliminar
                  </Button> 
                  {/* <Button
                    variant="success"
                    onClick={() => {
                      Historial(pagina);
                    }}
                  >
                    Historial
                  </Button> */}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      {/* <Button onClick={añadirProductoPresentaciones}> Agregar Pallet o caja</Button> */}
      <Button id="boton_regresar_ordenes" onClick={()=>{Reset()}}> Regresar</Button>
      <br/>
      <br/>
    </Container>
  </div>  
:
null
}

{presentaciones?
<div id="Fondo_verde">
  <br/>
  <br/>
  <br/>
  <br/>

  {ModalDiario && (
      <ModalProduccion_diaria
        ModalDiario={ModalDiario}
        setModalDiario={setModalDiario}
        actualizarEstadoProductos={actualizarEstadoProductos}
        usuario={usuario}
        pagina={pagina}
        start={start}
        Presentacion={Presentacion}
        setProductosPresentaciones={setProductosPresentaciones}
      />
    )} 

{ModalSemanal && (
      <ModalProduccion_semanal
        ModalSemanal={ModalSemanal}
        setModalSemanal={setModalSemanal}
        actualizarEstadoProductos={actualizarEstadoProductos}
        usuario={usuario}
        pagina={pagina}
        start={start}
        Presentacion={Presentacion}
        setProductosPresentaciones={setProductosPresentaciones}
      />
    )} 
  
  <Stack direction="horizontal" className="justify-content-between">
    <Button id="Boton_regresar_menu_principal_presentaciones" onClick={()=>{produccion_diaria()}}>Resumen Produccion diaria</Button>
    <Button onClick={()=>{produccion_semanal()}}>Resumen produccion semanal</Button>
    <Button id="Boton_regresar_menu_principal_presentaciones2" onClick={()=>{Pagina_principal()}}>Regresar</Button>
  </Stack>
  
  <h1 id="Titulo_presentaciones2" >Por favor, seleccionar la linea de producción</h1>
  <button id="Botones_presentaciones" className="btn btn-secondary" onClick={Tomate_seleccion}> Tomate</button>
  <button id="Botones_presentaciones" className="btn btn-secondary" onClick={()=>{Calabaza_seleccion(); }}> Calabaza</button>
  <button id="Botones_presentaciones" className="btn btn-secondary" onClick={()=>{Chile_seleccion(); }}> Chile</button>
  <button id="Botones_presentaciones" className="btn btn-secondary" onClick={()=>{Tomatillo_seleccion(); }}> Tomatillo</button>
  <br/>
  <br/>

  
</div>  
  :
    null
  }  
   
{Embarque_cliente && (
<div>
<Container fluid id="Navbar_trabajo_home">
      {isModalAñadir && (
      <ModalAñadir_Embarque
        isModalAñadir={isModalAñadir}
        setIsModalAñadir={setIsModalAñadir}
        actualizarEstadoManifiestos={actualizarEstadoManifiestos}
        productoEditar={productoEditar}
        productos_manifiestos={productos_manifiestos}
        usuario={usuario}
      />)}
      {isModalEditar && (
        <ModalEditar_Embarque
          isModalEditar={isModalEditar}
          setIsModalEditar={setIsModalEditar}
          actualizarEstadoManifiestos={actualizarEstadoManifiestos}
          productoEditar={productoEditar}
          setproductos_manifiestos={setproductos_manifiestos}
          usuario={usuario}
          pagina={pagina}
          start={start}
        />
      )}
      {isModalClientes && (
        <ModalClientes_Embarque
          isModalClientes={isModalClientes}
          setisModalClientes={setisModalClientes}
          actualizarEstadoProductos={actualizarEstadoProductos}
          productoEditar={productoEditar}
          setProductoEditar={setProductoEditar}
          usuario={usuario}
          pagina={pagina}
          start={start}
        />
      )}
      {Cartera_nacional && (
        <ModalCartera_nacional
          Cartera_nacional={Cartera_nacional}
          setCartera_nacional={setCartera_nacional}
          actualizarEstadoProductos={actualizarEstadoProductos}
          productoEditar={productoEditar}
          setProductoEditar={setProductoEditar}
          usuario={usuario}
          pagina={pagina}
          start={start}
          Manifiesto_Seleccionado={Manifiesto_Seleccionado}
        />
      )}
      {Cartera_exportacion && (
        <ModalCartera_exportacion
          Cartera_exportacion={Cartera_exportacion}
          setCartera_exportacion={setCartera_exportacion}
          actualizarEstadoProductos={actualizarEstadoProductos}
          productoEditar={productoEditar}
          setProductoEditar={setProductoEditar}
          usuario={usuario}
          pagina={pagina}
          start={start}
        />
      )}
      {PALLETS && (
        <ModalPallets
          PALLETS={PALLETS}
          setPALLETS={setPALLETS}
          actualizarEstadoProductos={actualizarEstadoProductos}
          productoEditar={productoEditar}
          setProductoEditar={setProductoEditar}
          usuario={usuario}
          pagina={pagina}
          start={start}
        />
      )}
      <br/>
      <Stack direction="horizontal" className="justify-content-between">
        <p style={{ fontSize: 16 }}>Actualmente estas en {window.location.pathname} de la sección {pagina}</p>
        {ADMIN_ON && (   
              <Button onClick={()=>{setCartera_nacional(true)}}> Cartera nacional</Button> 
          )} 

          {ADMIN_ON && (
              <Button onClick={()=>{setCartera_exportacion(true)}}> Exportación</Button>
          )}     

        <Button onClick={()=>{setPALLETS(true)}}> Pallets actuales</Button>
        <Button id="boton_regresar_ordenes" onClick={()=>{Embarque_Modal_clientes()}}> Clientes</Button>
        <Button onClick={añadirProductoHome}> Nuevo manifiesto</Button>
        <Button id="boton_regresar_ordenes" onClick={()=>{Pagina_principal()}}> Regresar</Button>
        <Button onClick={signOut}>Cerrar sesión</Button>
      </Stack>
      <hr /> 
      <Table>
        <thead>
          <tr>
            <th>Manifiesto</th>
            <th>Cliente</th>
            <th>Nacional o exportación</th>
            <th>Chofer</th>
            <th>Celular</th>
            <th>Placas trailer</th>
            <th>Placas caja</th>
            {/* <th>Total kilos</th> */}
            <th>Acciones</th>
           {/*  <th>Acciones</th> */}
          </tr>
        </thead>
        <tbody>
          {productos_manifiestos &&
            productos_manifiestos.map((producto, index) => (
              <tr key={index}>
                <td>#{producto.manifiesto}</td>
                <td>{producto.cliente}</td>
                <td>{producto.nacional_exportacion2}</td>
                <td>{producto.chofer}</td>
                <td>{producto.celular}</td>
                <td>{producto.placas}</td>
                <td>{producto.placas_caja}</td>
                {/* <td style={{ textAlign: "right" }}>{formatter.format(producto.total_flete)}</td> */}
                <td>
                  <Button
                    variant="dark"
                    onClick={() => {
                      setProductoEditar({ ...producto });
                      setIsModalEditar(true);
                    }}
                  >
                    Editar
                  </Button>

                  <Button
                    variant="warning"
                    onClick={() => {
                      pdfGenerate1(producto)
                    }}
                  >
                   PDF
                  </Button>

                  <Button
                    variant="success"
                    onClick={() => {
                      EmbarqueOFF(producto);
                    }}
                  >
                    Pallets
                  </Button>

                  <Button
                    variant="danger"
                    onClick={() => {
                      eliminar_sweetalert(producto, usuario);
                    }}
                  >
                    Eliminar
                  </Button>
                  
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
{/*       <Button onClick={añadirProductoHome}> Retirar Producto</Button>
      <Button id="boton_regresar_ordenes" onClick={()=>{Pagina_principal()}}> Regresar</Button> */}
      <br/>
      <br/>
    </Container>
</div>
)}


{Manifiestos_pallets && (
<div>
<Container fluid id="Navbar_trabajo_home">
      {ModalAñadir_Manifiesto_palletsON && (
      <ModalAñadir_Manifiesto_pallets
        ModalAñadir_Manifiesto_palletsON={ModalAñadir_Manifiesto_palletsON}
        setModalAñadir_Manifiesto_palletsON={setModalAñadir_Manifiesto_palletsON}
        setManifiestos_pallets_datos={setManifiestos_pallets_datos}
        Manifiesto_Seleccionado={Manifiesto_Seleccionado}
        usuario={usuario}
        pagina={pagina}
        start={start}
        setProductos={setProductos}
        Embarque_cliente={Embarque_cliente}
        Gastoson={Gastoson}
      />)}
      {isModalEditar && (
        <ModalEditar_Manifiesto_pallets
          isModalEditar={isModalEditar}
          setIsModalEditar={setIsModalEditar}
          actualizarEstadoProductos={actualizarEstadoProductos}
          productoEditar={productoEditar}
          setProductoEditar={setProductoEditar}
          usuario={usuario}
          pagina={pagina}
          start={start}
        />
      )}
      {agregar_precios_pallets && (
        <Modalagregar_precios_pallets
        agregar_precios_pallets={agregar_precios_pallets}
          setagregar_precios_pallets={setagregar_precios_pallets}
          actualizarEstadoProductos={actualizarEstadoProductos}
          productoEditar={productoEditar}
          setProductoEditar={setProductoEditar}
          usuario={usuario}
          Manifiesto_Seleccionado={Manifiesto_Seleccionado}
        />
      )}
      {ModalAñadir_Manifiesto_facturas && (
        <ModalAñadir_manifiesto_facturas
          isModalAñadir_Manifiesto_facturas={ModalAñadir_Manifiesto_facturas}
          setModalAñadir_Manifiesto_facturasON={setModalAñadir_Manifiesto_facturasON}
          setManifiestos_pallets_datos={setManifiestos_pallets_datos}
          actualizarEstadoProductos={actualizarEstadoProductos} 
          productoEditar={productoEditar}
          setProductoEditar={setProductoEditar}
          usuario={usuario}
          Manifiesto_Seleccionado={Manifiesto_Seleccionado}
        />
      )}
      <br/>
      <Stack direction="horizontal" className="justify-content-between">
        <p style={{ fontSize: 16 }}>Actualmente estas en {window.location.pathname} de la sección {pagina}</p>
        <Button onClick={()=>{setModalAñadir_Manifiesto_palletsON(true)}}> Agregar pallet</Button>
        <Button onClick={()=>{setModalAñadir_Manifiesto_facturasON(true)}}> Agregar facturas</Button>
        
        {ADMIN_ON && (
        <Button onClick={()=>{setagregar_precios_pallets(true)}}> Agregar precios</Button>
          )}  
        <Button id="boton_regresar_ordenes" onClick={()=>{setManifiestos_pallets(false); setEmbarque_cliente(true); actualizarEstadoManifiestos();}}> Regresar</Button>
        <Button onClick={signOut}>Cerrar sesión</Button>
      </Stack>
      <hr /> 
      <Table>
        <thead>
          <tr>
          <th>#</th>
            <th>Tarima</th>
            <th>Cantidad</th>
            <th>Fecha</th>
            <th>Lugares en la caja del trailer</th>
            <th>Usuario</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {Manifiestos_pallets_datos &&
            Manifiestos_pallets_datos.map((producto, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{producto.tarima_seleccionada}</td>
                <td>{producto.cantidad_retirada}</td>
                <td>{producto.fecha}</td>
                <td>{producto.checkbox_seleccionados}</td>
                <td>{producto.usuario2}</td>
                <td>
                  {/* <Button
                    variant="dark"
                    onClick={() => {
                      setProductoEditar({ ...producto });
                      setIsModalEditar(true);
                    }}
                  >
                    Editar
                  </Button> */}
                  <Button
                    variant="danger"
                    onClick={() => {
                      eliminar_sweetalert2(producto);
                    }}
                  >
                    Eliminar
                  </Button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
{/*       <Button onClick={añadirProductoHome}> Retirar Producto</Button>
      <Button id="boton_regresar_ordenes" onClick={()=>{Pagina_principal()}}> Regresar</Button> */}
      <br/>
      <br/>
    </Container>
</div>
)}
  



</div> 
  );
}

export default Home_Produccion;
